import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/contract',
    component: () =>
      // import(/* webpackChunkName: "homeChunk" */ '@/pages/Contract.vue') // 不起效
      import('@/pages/Contract.vue')
  },
  {
    path: '/contract2',
    component: () =>
      // import(/* webpackChunkName: "homeChunk" */ '@/pages/Contract.vue') // 不起效
      import('@/pages/Contract2.vue')
  },
  {
    path: '/contract-en',
    component: () => import('@/pages/Contract-en.vue')
  },
  {
    path: '/privacy',
    component: () => import('@/pages/Privacy.vue')
  },
  {
    path: '/privacy-en',
    component: () => import('@/pages/Privacy-en.vue')
  },
  {
    path: '/privacy_ems',
    component: () => import('@/pages/Privacy-EMS.vue')
  },
  {
    path: '/privacyChild',
    component: () => import('@/pages/PrivacyChild.vue')
  },
  {
    path: '/privacyChild-en',
    component: () => import('@/pages/PrivacyChild-en.vue')
  },
  {
    path: '/download',
    component: () => import('@/pages/Download.vue')
  },
  {
    path: '/download2',
    component: () => import('@/pages/Download2.vue')
  },
  {
    path: '/download3',
    component: () => import('@/pages/Download3.vue')
  },
  {
    path: '/download4',
    component: () => import('@/pages/Download4.vue')
  },
  {
    path: '/downloadHems',
    component: () => import('@/pages/Download-HEMS.vue')
  },
  {
    path: '/hotspotGuide',
    component: () => import('@/pages/hotspotGuide.vue')
  },
  {
    path: '/station/model',
    component: () => import('@/pages/station/model.vue')
  },
  {
    path: '/logoutTip',
    component: () => import('@/pages/LogoutTip.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/contract'
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
